module.exports = "/service-worker"